export { default as VaultCard } from './VaultCard';
export { VaultImage } from './VaultCard';

export type VaultStatus = 'UNLOCKED' | 'LOCKED' | 'INACTIVE';
